import { Grid } from "@material-ui/core";
import CardInscricao from "components/Cards";
import LogoCNM from 'Imagens/logo-cnm-rodape.png';
import municipalismo from 'Imagens/background.jpg';
import { useDevice } from "components/DeviceContext.js";

const Home = () => {
    const {isMobile} = useDevice();
    return (
        <>
            <Grid container style={{
                backgroundColor: 'var(--azul)',
                minHeight: '75vh',
                paddingTop: '1em',
                boxShadow: '0px -4px 20px 0px rgba(0, 0, 0, 0.2)',
                backgroundImage: `url(${municipalismo})`,
                backgroundPosition: isMobile ? '70% top' : 'right -120px top',
                backgroundSize: isMobile ? '1000px' : 'cover',
                backgroundRepeat: 'no-repeat'
            }}>
                <Grid item xs={12} sm={6} md={6} style={{
                    justifyContent: 'center',
                    display: 'flex',
                    marginTop: isMobile ? '14em' : '1em'
                }}>
                    <CardInscricao />
                </Grid>
                <Grid item xs={12} sm={6} style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    position: 'relative'
                }}>
                    <img alt="Logo CNM" src={LogoCNM} />

                </Grid>
            </Grid>
        </>
    );
}

export default Home;
